import { cn } from '@/utils/format';

type UrgencyPillProps = {
  label: string;
  tone: 'red' | 'amber' | 'green';
};

const TONES: Record<UrgencyPillProps['tone'], string> = {
  red: 'bg-red-100 text-red-800',
  amber: 'bg-amber-100 text-amber-800',
  green: 'bg-green-100 text-green-800',
};

export const UrgencyPill = ({ label, tone }: UrgencyPillProps) => (
  <span
    className={cn('inline-flex rounded-full px-2 py-0.5 text-xs font-medium', TONES[tone])}
    data-testid="urgency-pill"
  >
    {label}
  </span>
);
